/**
 * GovernanceGate — protegge il cruscotto riservato del Protocollo.
 * Ammessi: Super Admin (flag/token), account verificati kind comune|proloco.
 * Negato: redirect alla vetrina pubblica /protocollo?riservato=1.
 */
import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { accountMe } from "../../api";
import { is6AmicoAdmin } from "../../utils/adminGate";

const ALLOWED_KINDS = new Set(["comune", "proloco"]);

export default function GovernanceGate({ children, fallback }) {
  const [state, setState] = useState("checking"); // checking | granted | denied

  useEffect(() => {
    let mounted = true;
    async function verify() {
      if (is6AmicoAdmin()) {
        if (mounted) setState("granted");
        return;
      }
      const token = localStorage.getItem("6amico_account_token");
      if (!token) {
        if (mounted) setState("denied");
        return;
      }
      try {
        const account = await accountMe();
        const ok =
          account?.is_super_admin === true || ALLOWED_KINDS.has(account?.kind);
        if (mounted) setState(ok ? "granted" : "denied");
      } catch {
        try {
          localStorage.removeItem("6amico_account_token");
          localStorage.removeItem("6amico_account_kind");
          localStorage.removeItem("6amico_account_slug");
        } catch {
          /* storage bloccato */
        }
        if (mounted) setState("denied");
      }
    }
    verify();
    return () => {
      mounted = false;
    };
  }, []);

  if (state === "checking") {
    return (
      <div
        className="gov-dash flex items-center justify-center min-h-[60vh] text-[var(--gov-stone-muted)]"
        role="status"
        data-testid="governance-gate-loading"
      >
        Verifica accesso al cruscotto di governance…
      </div>
    );
  }

  if (state === "denied") {
    if (fallback) return fallback;
    return <Navigate to="/protocollo?riservato=1" replace />;
  }

  return children;
}
